// src/components/renderers/MultipleResponseRenderer.js
import React from 'react';

const MultipleResponseRenderer = ({ 
  question, 
  userAnswer = [], 
  onAnswerChange, 
  showFeedback,
  showCorrectAnswers 
}) => {
  const content = question.content || {};
  const options = content.options || [];

  const handleToggle = (optionId) => {
    if (!showFeedback && onAnswerChange) {
      let newAnswer;
      if (userAnswer.includes(optionId)) {
        newAnswer = userAnswer.filter(id => id !== optionId);
      } else {
        newAnswer = [...userAnswer, optionId];
      }
      onAnswerChange(newAnswer);
    }
  };

  const getOptionClass = (option) => {
    const classes = ['multiple-option'];
    
    if (userAnswer.includes(option.id)) {
      classes.push('selected');
    }

    if (showFeedback || showCorrectAnswers) {
      if (option.isCorrect) {
        classes.push('correct');
      } else if (userAnswer.includes(option.id) && !option.isCorrect) {
        classes.push('incorrect');
      }
    }

    return classes.join(' ');
  };

  return (
    <div className="question-renderer multiple-response-renderer">
      <div className="question-stem" dangerouslySetInnerHTML={{ __html: content.stem || '' }} />
      <p className="instruction-text">Select all correct answers</p>

      <div className="options-container">
        {options.map((option, index) => (
          <div
            key={option.id}
            className={getOptionClass(option)}
            onClick={() => handleToggle(option.id)}
          >
            <div className="checkbox-wrapper">
              <div className="checkbox">
                {userAnswer.includes(option.id) && <span className="checkmark">✓</span>}
              </div>
            </div>
            <div className="option-text">{option.text}</div>
            {(showFeedback || showCorrectAnswers) && option.isCorrect && (
              <div className="correct-indicator">✓</div>
            )}
          </div>
        ))}
      </div>

      {showFeedback && content.generalFeedback && (
        <div className="feedback-section">
          <div className="general-feedback">
            <strong>Feedback:</strong> {content.generalFeedback}
          </div>
        </div>
      )}
    </div>
  );
};

export default MultipleResponseRenderer;